import React from 'react';
import { C } from '../constants';

export const Orbs = () => (
  <div
    style={{
      position: 'absolute',
      inset: 0,
      pointerEvents: 'none',
      overflow: 'hidden',
      zIndex: 0
    }}
  >
    <div
      style={{
        position: 'absolute',
        top: '10%',
        left: '5%',
        width: '500px',
        height: '500px',
        background: `radial-gradient(circle, ${C.primary}40 0%, transparent 70%)`,
        borderRadius: '50%',
        animation: 'pulse 8s ease-in-out infinite',
        filter: 'blur(60px)'
      }}
    />
    <div
      style={{
        position: 'absolute',
        bottom: '10%',
        right: '5%',
        width: '400px',
        height: '400px',
        background: `radial-gradient(circle, ${C.secondary}30 0%, transparent 70%)`,
        borderRadius: '50%',
        animation: 'pulse 6s ease-in-out infinite 1s',
        filter: 'blur(60px)'
      }}
    />
    <style>{`
      @keyframes pulse {
        0%, 100% { transform: scale(1); opacity: 0.3; }
        50% { transform: scale(1.1); opacity: 0.5; }
      }
    `}</style>
  </div>
);

export const Grid = ({ o = 0.05 }) => (
  <div
    style={{
      position: 'absolute',
      inset: 0,
      backgroundImage: `
        linear-gradient(rgba(255,255,255,${o}) 1px, transparent 1px),
        linear-gradient(90deg, rgba(255,255,255,${o}) 1px, transparent 1px)
      `,
      backgroundSize: '50px 50px',
      pointerEvents: 'none',
      zIndex: 0
    }}
  />
);